type GtagFn = (...args: unknown[]) => void;

function getGtag(): GtagFn | null {
  if (
    typeof window !== 'undefined' &&
    typeof (window as unknown as { gtag?: GtagFn }).gtag === 'function'
  ) {
    return (window as unknown as { gtag: GtagFn }).gtag;
  }
  return null;
}

export function trackEvent(name: string, params?: Record<string, unknown>) {
  getGtag()?.('event', name, params);
}

export function updateConsent(granted: boolean) {
  getGtag()?.('consent', 'update', {
    analytics_storage: granted ? 'granted' : 'denied',
    ad_storage: granted ? 'granted' : 'denied',
  });
}

export function trackPageView(path: string) {
  getGtag()?.('event', 'page_view', { page_path: path });
}
